import { useContext, useEffect } from 'react'
import { ApplicationContext } from '../context/application'
import { useBenefitsAnswerQueryLazyQuery } from 'types/graphql'
import { useRouter } from 'next/router'

export const useBenefitsAnswers = function useBenefitsAnswers() {
    const applicationContext = useContext(ApplicationContext)
    const router = useRouter()
    const [getBenefitsAnswers, { data, loading, error, refetch }] = useBenefitsAnswerQueryLazyQuery()

    useEffect(() => {
        const applicationId = router.query.applicationId?.toString()

        if (applicationId && applicationContext?.profile?.person?.id) {
            void getBenefitsAnswers({ variables: { personId: applicationContext?.profile?.person?.id } })
        }
    }, [router, loading])

    useEffect(() => {
        if (data) {
            applicationContext.setBenefits(data.benefitsAnswers)
        }
    }, [data])

    const getBenefitsAnswersByCategory = (category: string) => {
        return applicationContext.benefits.filter((answer: { category: string }) => {
            return answer.category === category
        })
    }

    return {
        getBenefitsAnswersByCategory,
        loading,
        error,
        refetch,
    }
}
